import { render, staticRenderFns } from "./Inspect.vue?vue&type=template&id=5c1b2700"
import script from "./Inspect.vue?vue&type=script&lang=js"
export * from "./Inspect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports